<template>
    <span class="num_result">{{count}}</span>
</template>

<script>
    import { ref, onMounted } from "vue"
    export default ({
        props: {
        },
        setup (props, context) {
            const count = ref("-")

            onMounted(() => {
                axios.get("/api/allCount/")
                .then(function (response) {
                    count.value = response.data.count.toLocaleString()
                })
            })

            return {
                count,
            }
        },
    })
</script>